import { render, staticRenderFns } from "./candidate-location-component.vue?vue&type=template&id=f5fecaf4&scoped=true"
import script from "./candidate-location-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-location-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-location-component.scss?vue&type=style&index=0&id=f5fecaf4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fecaf4",
  null
  
)

export default component.exports